<main class="container" id="main">
    <div class="container__inner">
        <app-breadcrumb></app-breadcrumb>
        <ng-content></ng-content>
    </div>
</main>
